import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { injectHasRoleAccess } from "@shared/auth/role.guard";
import { EmptyComponent } from "@shared/empty/empty.component";
import { Button } from "@ui";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.css"],
  imports: [EmptyComponent, Button],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);
  readonly #hasRoleAccess = injectHasRoleAccess();

  protected readonly title = this.#route.snapshot.data["title"] ?? "Page not found";
  protected readonly body =
    this.#route.snapshot.data["body"] ?? "The page you're looking for does not exist at this address.";
  protected readonly hasHomeAccess = this.#hasRoleAccess("home:full");

  protected redirectToHome() {
    this.#router.navigate(["/core/home"]);
  }
}
